import { Typography } from '@material-ui/core';
import { withStyles, withTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { globalStyles } from '../style/gstheme';
import AddSubscriptionContainer from '../subscription/AddSubscriptionContainer';

const styles = () => {
  return Object.assign({
    priceHeading: {
      fontFamily: 'Rajdhani',
      fontWeight: 500,
      fontSize: '34px',
      marginTop: '12px'
    },
    userCount: {
      fontSize: '14px',
      color: '#616161'
    }
  }, globalStyles);
};

class BuySubscription extends Component {

  render() {

    const { classes, name, price, dollarPrice, wide, userCount, free, setSubscription, onNewSubscription } = this.props;
    const userCountText = userCount === 1 ? '1 User' : `Up to ${userCount} users`;

    return (
      <div style={{ textAlign: 'center', width: wide ? '200px' : '160px', padding: '0px 5px 0px 5px' }}>
        <div style={{ marginBottom: 30 }}>
          <Typography className={classes.mainHeading}>{name}</Typography>
          <Typography className={classes.priceHeading}>{free ?
            <span><span>Free</span><br/><span>&#160;</span></span>
            :
            <span><span>£{price}</span><br/><span>${dollarPrice}</span></span>
          }</Typography>
          <Typography className={classes.userCount}>{userCountText}</Typography>
        </div>
        <AddSubscriptionContainer
          onNewSubscription={onNewSubscription}
          selected={name}
          inverted={free}
          name={free ? 'Try for Free' : 'Get Started'}
          setSubscription={setSubscription} />
      </div>
    );
  }
}

BuySubscription.propTypes = {
  classes: PropTypes.object,
  wide: PropTypes.bool,
  onNewSubscription: PropTypes.func.isRequired,
  setSubscription: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  price: PropTypes.string,
  dollarPrice: PropTypes.string,
  userCount: PropTypes.number.isRequired,
  free: PropTypes.bool.isRequired
};

export default withTheme(withStyles(styles)(BuySubscription));